module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Prologue")])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The legend")])])])]), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("O")])])])]), _vm._v("n the night of January 10, 1922, a full moon rose over the frozen countryside near Adamant, Arkansas, a tiny community five miles north of the Louisiana state line. The pale light glinted on freshly fallen snow and spotlighted the oil derrick recently constructed in Thomas Duncan’s barren cotton fields.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Despite the gusher that had been discovered on his property a few months after the Busey Number One had come in near El Dorado, Thomas refused to move to more comfortable accommodations in town, preferring instead to remain on the family farm he’d inherited from his father nearly half a century earlier.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Thomas liked being in the country. His nearest neighbor was nearly two miles away and he did sometimes get lonely, but the farm made him feel closer to his wife, Mary, who had passed away five years ago. She’d been laid to rest beneath a stand of cottonwoods on a hillock overlooking the river, and Thomas had tied bells in the branches so she would have music whenever a breeze stirred.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("All day long, the chime of the bells had been lost in the icy howl of an Arctic cold front that roared down from the northeast. The gusts had finally abated in the late afternoon, but the weather was still bitter, even for January, and a snowfall—the first Thomas could remember in over a decade—blanketed his yard and fields in a wintry mantel. He watched the swirl of flakes from his front room window until dusk. Inexplicably uneasy, he fixed an early supper and went up to bed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Something awakened him around midnight. The snow brought a preternatural quiet to the countryside, the silence so profound that Thomas could easily discern the pump out in the field as it siphoned oil from deep within the earth. Early on, the mechanical rhythm had kept him awake until all hours, but he was used to it now and that wasn’t what had disturbed his rest.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Still half-asleep, he thought at first he’d heard a gunshot and he wondered if someone was out tracking a deer. Then he worried there might have been an explosion at the well; he got up to glance out the window where the wooden derrick rose like an inky shadow from the pristine layer of snow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As he crawled back under the warm covers, he heard the sound again, a loud, steady clank, like something being dropped against the tin roof of his house.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Or like heavy footsteps.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The hair at the back of Thomas’s neck lifted as a terrible dread gripped him. He scrambled out of bed, pulled on his clothes and grabbed a shotgun and coat on his way outside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Using a side door to avoid the slippery porch, he trudged around to the front of the house where he had a better view of the roof.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The moon was bright on the snow, a luminous glow that turned nighttime into a subdued twilight, and the air was pure and so cold that his nostrils stung when he breathed. He turned, looked up and what he saw chilled him to the bone. Cloven footprints started at the edge of the roof, moved in a straight line up the sloping tin and disappeared over the peak.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Slowly, Thomas turned in a circle, his gaze encompassing the yard, the barn, the cotton fields and finally returning to his house and then up the porch steps right to his front door. He saw now what he had not noticed before. The footprints were everywhere. He’d never seen anything like them. He’d lived in the country all his life and he knew the tracks hadn’t been made by a four-legged animal, but by something that walked upright. And the stride was long and at least twice as wide as the footprints Thomas had left in the snow.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A terrible premonition settled over him. The farmhouse had been his home since he was a boy, and on Sunday mornings when his neighbors headed into town for church services, he had instead walked the fields alone. The peace he found there was deep and profound, the clean silence of the freshly plowed earth more suited to his idea of prayer and reflection. But now, as he stood in his own front yard, Thomas Duncan had the sense that a part of his heritage had been desecrated.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("An urgency he couldn’t explain prodded him, and he rushed back to the house, avoiding the prints on the steps and across the frozen porch as he flung open the front door. His heart hammered against his chest as he stepped inside, expecting to see melting tracks on the plank flooring. The only snow, however, was from his own boots.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Quickly he bolted the door and strode down the narrow hallway to the kitchen. As he opened the back door, his gaze dropped. The prints started at the threshold and continued down the steps and across the yard to the open field, as if something had come in the front door, passed through the house without leaving a mark, and let itself out the back way.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("More afraid than he’d ever been in his life, Thomas moved back inside and clicked the thumb-lock on the door. He shoved a chair under the knob and sat down at the table, shotgun across his knees, to wait for daylight.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("By morning, word of the footprints had spread throughout the town, and with it, speculation as to their source. One of Thomas’s neighbors followed the tracks right up to the edge of the river where they continued in the same straight line on the other side.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For several nights after that, some of the men sat up with Thomas, waiting to see if the strange phenomenon reoccurred. When nothing happened, the community began to breathe a little easier—until a local preacher sermonized that the drillers, in their quest to strike it rich, had somehow punched a hole straight down to hell, unleashing the devil himself to run unbridled across the countryside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The cloven footprints vanished with the melting snow and were eventually forgotten in the tiny Arkansas community.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Then seven decades later, they reappeared near the mutilated body of sixteen-year-old Rachel DeLaune.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea72fad2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/devilsfootprintsthe_fm01.vue
// module id = 69
// module chunks = 0